import { DropdownMenu as M } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const Menu = M.Root;
export const MenuTrigger = M.Trigger;

export const overlaySurface =
  'z-50 rounded-panel bg-overlay p-1.5 shadow-float data-[state=open]:animate-pop';

export function MenuContent({ className, children, ...props }: ComponentProps<typeof M.Content>) {
  return (
    <M.Portal>
      <M.Content
        sideOffset={6}
        collisionPadding={12}
        className={cn(overlaySurface, 'min-w-52', className)}
        {...props}
      >
        {children}
      </M.Content>
    </M.Portal>
  );
}

export function MenuItem({
  className,
  icon,
  children,
  danger,
  ...props
}: ComponentProps<typeof M.Item> & { icon?: ReactNode; danger?: boolean }) {
  return (
    <M.Item
      className={cn(
        'flex h-9 cursor-default items-center gap-2.5 rounded-[9px] px-2.5 text-[13.5px] outline-none select-none data-[disabled]:opacity-40 data-[highlighted]:bg-hover [&_svg]:size-4 [&_svg]:text-fg-muted',
        danger && 'text-danger [&_svg]:text-danger',
        className,
      )}
      {...props}
    >
      {icon}
      {children}
    </M.Item>
  );
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <M.Label className="px-2.5 pt-2 pb-1 text-[12px] text-fg-subtle">{children}</M.Label>;
}

export function MenuSeparator() {
  return <M.Separator className="my-1.5 h-px bg-line" />;
}

export const MenuRadioGroup = M.RadioGroup;
export function MenuRadioItem({ children, ...props }: ComponentProps<typeof M.RadioItem>) {
  return (
    <M.RadioItem
      className="flex h-9 cursor-default items-center gap-2.5 rounded-[9px] px-2.5 text-[13.5px] outline-none data-[highlighted]:bg-hover data-[state=checked]:text-fg"
      {...props}
    >
      <span className="flex size-4 items-center justify-center">
        <M.ItemIndicator>
          <span className="block size-1.5 rounded-full bg-signal" />
        </M.ItemIndicator>
      </span>
      {children}
    </M.RadioItem>
  );
}
